import {type RouteRecordRaw} from 'vue-router';
import {addSessionserviceRoutes} from './sessionservice';

const module = 'meetingservice';

let meta: MetaData = {
    module: module,
};

let routes: RouteRecordRaw[] = [];

addSessionserviceRoutes(routes, module, meta);

export default routes;
